export default __webpack_public_path__ + "static/media/streamify.02734045.svg";